import { render, staticRenderFns } from "./UserBestellungDetail.vue?vue&type=template&id=8c8e1f52&"
import script from "./UserBestellungDetail.vue?vue&type=script&lang=js&"
export * from "./UserBestellungDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports